<script setup lang="ts">
import type { BlockCardGrid } from '~/types';

const props = defineProps<{
  data: BlockCardGrid;
}>();

const cards = computed(() => (Array.isArray(props.data.cards) ? props.data.cards : []));

const gridColumns = computed(() => {
  if (cards.value.length >= 4) {
    return 'lg:grid-cols-4';
  }

  if (cards.value.length === 2) {
    return 'lg:grid-cols-2';
  }

  return 'lg:grid-cols-3';
});
</script>
<template>
  <BlockContainer full-width class="mx-10 bg-[#141414] dark:bg-[#141414]">
    <UContainer>
      <!-- <TypographyTitle v-if="data.title">{{ data.title }}</TypographyTitle> -->
      <TypographyHeadline v-if="data.title" :content="data.title" size="lg" class="text-white" />
    </UContainer>
    <br >
    <UContainer v-if="cards.length" class="mb-6">
      <!-- Responsive grid replaces ULandingGrid (removed in Nuxt UI v4) -->
      <div :class="['flex flex-col lg:grid gap-8', gridColumns]">
        <span v-for="card in cards" :key="(card as any)?.id">
          <BlocksLandingCard v-if="card" :data="card" />
        </span>
      </div>
    </UContainer>
  </BlockContainer>
</template>
